import {updateLabelConfig} from '../../../data/labelInfos/index.js'
import ConfigCheckbox from './ConfigCheckbox.js'
import {SHIPPO, USPS_SHIP} from '../../../common/constants/ShipperNames.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'
import {
  defaultValidLabelPropertiesFunc,
  ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
} from './useLabelProperty.js'

const LABEL_PROPERTY = 'ignore_bad_address'
const VALID_SHIPPER_TYPES = [SHIPPO, USPS_SHIP]

export default function IgnoreBadAddress() {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const propertySpecs = IgnoreBadAddress.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )

  return (
    <ConfigCheckbox
      label="Ignore Invalid Address"
      onChange={(checked) => {
        updateLabelConfig(labelInfoID, {[labelProperty]: checked})

        onChange()
      }}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
      helpLink="https://support.ordoro.com/does-ordoro-automatically-validate-the-shipping-addresses-on-every-order/#addressbypass"
      helpLinkHint="Delivery may be affected, learn more"
    />
  )
}

IgnoreBadAddress.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc() {
      return [LABEL_PROPERTY]
    },
    dependentPropertiesFunc: ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
  },
]
